import { RootState } from "src/redux/store";

export const impersonationSelector = (state: RootState) => state.userImpersonationStore;
